import React from "react";
import ContactDetails from "../components/ContactDetails";

const Contact = () => (
	<div className="mx-auto py-8 px-4">
		{/* Header Section */}
		<div className="px-0 md:px-12">
			<header className="text-center mb-8">
				<h1 className="text-4xl sm:text-5xl font-bold text-theme">
					Contact Us
				</h1>
				<p className="text-lg sm:text-xl text-gray-600 mt-4">
					Get in touch with us using the contact information below:
				</p>
			</header>

			{/* Contact Information Section */}
			<section>
				<h2 className="text-3xl sm:text-4xl mx-auto font-semibold text-theme mb-6">
					Our Contact Information
				</h2>
				<ContactDetails />
			</section>

			{/* Google Map Image Section */}
			<section className="mt-12">
				<h3 className="text-2xl font-semibold text-theme mb-4">
					Find Us
				</h3>
				<div className="aspect-w-16 aspect-h-9">
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4417.7613138635015!2d93.76669337606944!3d25.85935140456195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x374609b12eacb673%3A0xc92e49bc2be1a37!2sSacred%20Heart%20School!5e1!3m2!1sen!2sin!4v1733396465691!5m2!1sen!2sin"
						width="350"
						height="300"
						className="md:w-1/2 md:h-96"
						style={{ border: "0" }}
						allowFullScreen=""
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
						title="Sacred Heart School"
					></iframe>
				</div>
			</section>
		</div>
	</div>
);

export default Contact;
